__turbopack_context__.v({
  "chip": "Chip-module-scss-module__k2669q__chip",
  "selected": "Chip-module-scss-module__k2669q__selected",
  "unselected": "Chip-module-scss-module__k2669q__unselected",
});
